/*
  周扬
  2023.06.15
  制作VPN申请页面
*/ 
<template>
  <div class="PartsVpn mainWrap"><!--需要修添加class-->
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/VPN002"></leftNav><!--改组件名-->
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
          <a download=""></a>
          <el-main>
            <div class="mainWrao" v-loading="fullscreenLoading">
              <div class="recordTitle">
                <h1>{{$t('VpnReview.title')}}</h1>
              </div>
              <!-- 页面主体部分-->
              <div class="my">
              <!-- 内容 -->
                <div class="tableWrap">
                  <!-- 搜索条件 -->
                  <div class="datePick">
                      <el-row>
                        <!-- 申请人关键字搜索 -->
                        <label class="code-margin">{{$t('VpnReview.searchUser')}}：</label>
                        <el-input
                          class="code-select-width"
                          :placeholder="$t('VpnReview.enterUser')"
                          v-model="userContent"
                          clearable>
                        </el-input>
                        <!-- 一个按钮 -->
                        <div class="btns">
                            <el-button type="primary" size="small" icon="el-icon-search" @click="searchDataByButton()">{{$t('VpnReview.search')}}</el-button>
                        </div>
                      </el-row>
                  </div>

                  <!-- 表格 -->
                  <el-table
                    v-loading="loading"
                    :data="tableData"
                    style="width: 100%; text-align: center;"
                    :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')">
                    <!-- 公司名称 -->
                    <el-table-column
                        prop="machineEn"
                        :label="$t('VpnReview.company')"
                        max-width="200">
                        <template slot-scope="scope">
                          <span>{{scope.row.factoryName}}</span>
                        </template>
                    </el-table-column>
                    <!-- 盒子名称 -->
                    <el-table-column
                        prop="msgEn"
                        :label="$t('VpnReview.box')"
                        max-width="200">
                        <template slot-scope="scope">
                          <span>{{scope.row.boxMsg.boxName}}</span>
                        </template>
                    </el-table-column>
                    <!-- 申请人 -->
                    <el-table-column
                        prop="typeEn"
                        :label="$t('VpnReview.applyUser')"
                        max-width="200">
                        <template slot-scope="scope">
                          <span>{{scope.row.applicantName}}</span>
                        </template>
                    </el-table-column>
                    <!-- 申请时间 -->
                    <el-table-column
                        prop="descriptionEn"
                        :label="$t('VpnReview.applyTime')"
                        max-width="200">
                        <template slot-scope="scope">
                          <span>{{formatDate(scope.row.applyTime)}}</span>
                        </template>
                    </el-table-column>
                    <!-- 操作 -->
                    <el-table-column
                        prop="endStateDesEn"
                        :label="$t('VpnReview.operation')"
                        max-width="200">
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            type="success"
                            style="width: 60px;"
                            @click="handlePass(scope.row.id)">通过</el-button>

                          <el-button
                            size="mini"
                            type="danger"
                            style="width: 60px;"
                            @click="handleRefuse(scope.row.id)">拒绝</el-button>

                          </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- 分页 -->
                <el-pagination
                    class="pagination"
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :current-page.sync="nowPage"
                    @current-change="handleCurrentChange"
                    @size-change="handleCurrentSizeChange">
                </el-pagination>
              </div>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import leftNav from "@/components/nav.vue"
import { formatDate } from '../assets/js/date.js'

export default {
  name: 'VPN001',
  components: {
    leftNav
  },
  data () {
    return {
      // 全局加载控制
      fullscreenLoading: false,
      // 表格加载提示开关
      loading: false,
      // 当前页数
      nowPage: 1,
      // 每页大小
      nowPageSize: 10,
      // 总页数
      total: 1,
      // 搜索申请人关键字
      userContent:'',
      // 表格数据
      tableData: []
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    datevalue(){

    }
  },
  created(){
    this.searchData();
  },
  mounted() {
  
  },
  destroyed() {
  },
  methods: {
    // 分页-当前页码变化触发
    handleCurrentChange (val) {
      this.nowPage = val
      this.searchData()
    },
    // 分页-页码大小变化触发
    handleCurrentSizeChange (val) {
      this.nowPageSize = val
      this.searchData()
    },
    // 通过点击查询按钮查询数据
    searchDataByButton () {
      this.nowPage = 1
      this.searchData()
    },
    // 查询数据
    searchData () {
      this.loading = true
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/box/boxApplyList',
        params:{
          pageNum: _this.nowPage,
          pageSize: _this.nowPageSize,
          applicantName: _this.userContent //申请人关键字
        }
      }).then(function(res){
        _this.loading = false
        if (res.data.success === 'false') {
          _this.$message.error(res.data.msg);
        }else{
          _this.total = res.data.total//页码数
          _this.tableData = res.data.list
        }
      }).catch(function () {
          _this.loading = false
      })
    },
    // 申请通过
    handlePass (id) {
      this.$confirm('您确定要通过VPN申请吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.doReview(id,3)
      }).catch(() => {
        // 取消        
      });
    },
    // 申请拒绝
    handleRefuse (id) {
      this.$confirm('您确定要拒绝VPN申请吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.doReview(id,2)
      }).catch(() => {
        // 取消        
      });
    },
    // 执行申请
    doReview (id, status) {
      this.fullscreenLoading = true
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/box/handleBoxApply',
        params:{
          applyId: id,
          status: status,
          userId: _this.$store.state.authCode //审核人id
        }
      }).then(function(res){
        
        _this.fullscreenLoading = false
        if (res.data.success === 'false') {
          _this.$message.error(res.data.msg);
        }else{
          _this.checkPage()
          _this.searchData()
        }
          
      }).catch(function () {
          _this.fullscreenLoading = false
      })
    },
    checkPage () {
      let totals = this.total-1
      let pageNums = this.nowPage-1
      let allPageSize = pageNums*(this.nowPageSize)
      if (totals<=allPageSize) {
        if ((this.nowPage-1)>0) {
          this.nowPage = this.nowPage-1
        } else{
          this.nowPage = 1
        }
      }
    },
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>

<style scoped>
.PartsVpn{
   min-width: 1365px!important;/*最小宽度 */
}
.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 35px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}

/* 我的样式 */
.recordTitle div a {
  margin-left: 20px;
  color: #6bb4df;
}

.tableWrap{
  padding: 5px 30px;
}

.datePick{
  margin: 10px 0;
}
.datePick .btns{
  float: right;
}

.pagination{
  text-align: center;
  margin-top: 35px;
}

.type-select-width{
    width: 170px;
}
.code-select-width{
    width: 144px;
}
.code-margin{
    margin-left: 10px;
}

</style>

